import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Obtenemos el token del almacenamiento local
    const token = localStorage.getItem('token');

    // Headers base para todas las peticiones
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    // Si la URL contiene ngrok, agregamos el header para evitar la página de advertencia
    if (request.url.includes('ngrok')) {
      headers['ngrok-skip-browser-warning'] = 'true';
    }

    // Si hay un token, lo agregamos a los headers
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Clonamos la request con los headers actualizados
    request = request.clone({
      setHeaders: headers
    });

    // Continuamos con la solicitud modificada
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Manejo de errores de autenticación (401)
        if (error.status === 401) {
          // Limpiamos el token y redirigimos al usuario al login
          localStorage.removeItem('token');
          this.router.navigate(['/login']);
        }
        return throwError(() => error);
      })
    );
  }
}
